import { useMemo } from 'react';
import { z } from 'zod';

import { getMetaField } from '../meta-field';
import { validationErrors } from '../validation-errors';

const { getRequiredMessage, getFormatMessage } = validationErrors;

export const useValidation = () => {
	const metaField = useMemo(() => getMetaField(), []);

	const loginSchema = z.object({
		email: z
			.string()
			.email(getFormatMessage(metaField.email.label))
			.trim()
			.min(1, getRequiredMessage(metaField.email.label)),
		password: z.string().trim().min(1, getRequiredMessage(metaField.password.label)), //на вход пароль может быть любым
	});
	return { loginSchema };
};

export type Login = z.infer<ReturnType<typeof useValidation>['loginSchema']>;
